import { GoogleMaterialIcon } from '../ui/GoogleMaterialIcon';
import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";






import ToolTip from "../common/ToolTip";
import usePermission from "../../usePermission";
import { useCommonDetailsContext } from "../../context/Common/common";
import { tokens } from "../../theme/tokens";

export default function Toolbox(props: {
  displayComments: () => void;
  displayClientFiling: () => void;
  displayAddClientFiling: () => void;
  displayAttachments: () => void;
  displayHistory: () => void;
  updateBulkStatus: () => void;
  displayDocuments: () => void;
  displayConsolidatedView: () => void;
  // displayClientSpecificConsolidatedView: () => void;
  downloadData: () => void;
  downloadDataHistory: () => void;
  editMasterFilling: () => void;
  addMasterFilling: () => void;
  // deleteMasterRecord: () => void;
  deleteRecord: () => void;
  deleteClientFiling: () => void;
  printCalendar: () => void;
  isMasterFiling: boolean;
  selectedClientId: any;
  isDisabled: boolean;
  hasTrackNowAccess: boolean;
  hasPostAwaradAccess: boolean;
}) {
  const { publishedBranding, clientScopedBranding, validateParentData } = useCommonDetailsContext();
  const activeBranding = validateParentData?.isSingleParent ? publishedBranding : (clientScopedBranding || publishedBranding);
  const primaryColor =
    activeBranding?.primaryColor || tokens.colors.connectedPurple;
  let { clientId } = useParams();
  const [selectedClientId, setSelectedClientId] = React.useState(clientId);

  const navigate = useNavigate();
  const displayHome = () => {
    navigate("/");
  };
  const displayTrackerPage = () => {
    navigate(`/client-filing-tracker-list/${selectedClientId}`);
  };

  const displayComments = () => {
    props.displayComments();
  };

  const displayAttachments = () => {
    props.displayAttachments();
  };

  const displayHistory = () => {
    props.displayHistory();
  };
  const updateBulkStatus = () => {
    props.updateBulkStatus();
  };

  const displayDocuments = () => {
    props.displayDocuments();
  };
  const displayConsolidatedView = () => {
    props.displayConsolidatedView();
  };
  const editFilingMaster = () => {
    props.editMasterFilling();
  };

  const deleteClientAddedFiling = () => {
    props.deleteClientFiling();
  };

  const deleteFiling = () => {
    props.deleteRecord();
  };

  const handlePrint = () => {
    props.printCalendar();
  };

  const hasChangeStatusPermission = usePermission(
    "ClientFilingList",
    "changeStatus"
  );
  const hasStaffAssignedPermission = usePermission(
    "ClientFilingList",
    "changeStaff"
  );
  // console.log(
  //     "Global toolbox",
  //     "Status",
  //     hasChangeStatusPermission,
  //     "Staffs",
  //     hasStaffAssignedPermission
  // );

  return (
    <React.Fragment>
      <Box sx={{ 
        width: "100%", 
        bgcolor: "white",
        borderRadius: "50px !important",
        padding: "16px 8px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "8px"
      }}>
        <nav aria-label="main mailbox folders" style={{ width: "100%" }}>
          <List sx={{ padding: 0 }}>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton sx={{ justifyContent: "center", padding: "8px" }}>
                <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                  <GoogleMaterialIcon name="filter_list" color={primaryColor} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </List>
        </nav>
        <Divider sx={{ width: "80%", bgcolor: primaryColor }} />
        <nav aria-label="secondary mailbox folders" style={{ width: "100%" }}>
          <List sx={{ padding: 0 }}>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton disabled={props.isDisabled} onClick={displayHome} sx={{ justifyContent: "center", padding: "8px" }}>
                <ToolTip title="Home">
                  <GoogleMaterialIcon name="home" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton onClick={displayTrackerPage} sx={{ justifyContent: "center", padding: "8px" }}>
                <ToolTip title="Client Tracker">
                  <GoogleMaterialIcon name="view_list" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={editFilingMaster}
                disabled={
                  !usePermission(
                    "ClientFilingList",
                    "clientSpecificFiling",
                    props.selectedClientId
                  )
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Edit Client Filing Master">
                  <GoogleMaterialIcon name="edit" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={deleteClientAddedFiling}
                disabled={
                  !usePermission(
                    "ClientFilingList",
                    "deleteClientSpecificFiling",
                    props.selectedClientId
                  )
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Delete Client Filing">
                  <GoogleMaterialIcon name="delete" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={displayComments}
                disabled={
                  !usePermission(
                    "ClientFilingList",
                    "comments",
                    props.selectedClientId
                  )
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Comments">
                  <GoogleMaterialIcon name="comment" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={displayAttachments}
                disabled={
                  !usePermission(
                    "ClientFilingList",
                    "viewFinalAttachment",
                    props.selectedClientId
                  )
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Final Attachment">
                  <GoogleMaterialIcon name="attach_file" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={displayHistory}
                disabled={
                  !usePermission(
                    "ClientFilingList",
                    "activityHistory",
                    props.selectedClientId
                  )
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Activity History">
                  <GoogleMaterialIcon name="history" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={displayDocuments}
                disabled={
                  !usePermission(
                    "ClientFilingList",
                    "masterFilingRefDoc",
                    props.selectedClientId
                  )
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Reference Documents">
                  <GoogleMaterialIcon name="snippet_folder" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={updateBulkStatus}
                disabled={
                  // !usePermission(
                  //   "ClientFilingList",
                  //   "changeStatus",
                  //   props.selectedClientId
                  // )
                  !hasChangeStatusPermission &&
                  !hasStaffAssignedPermission &&
                  !props.selectedClientId
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Bulk Update">
                  <GoogleMaterialIcon name="edit_note" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={displayConsolidatedView}
                disabled={
                  // !usePermission(
                  //   "ClientFilingList",
                  //   "viewConsolidated",
                  //   props.selectedClientId
                  // )
                  !hasChangeStatusPermission &&
                  !hasStaffAssignedPermission &&
                  !props.selectedClientId
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Consolidated update">
                  <GoogleMaterialIcon name="groups" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton onClick={deleteFiling} sx={{ justifyContent: "center", padding: "8px" }}>
                <ToolTip title="Defer Filing">
                  <GoogleMaterialIcon name="delete_forever" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton onClick={handlePrint} sx={{ justifyContent: "center", padding: "8px" }}>
                <ToolTip title="Print">
                  <GoogleMaterialIcon name="print" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
          </List>
        </nav>
      </Box>
    </React.Fragment>
  );
}
